import { styled, Typography } from '@mui/material'

const H2 = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.main,
  fontFamily: theme.typography?.fontFamily,
  fontWeight: 700,
  fontSize: '1.5rem',
}));

export default H2